import React from 'react'
import styles from "./Projectdisplay.module.css"
import { useParams } from 'react-router-dom';
import Myproject from './Myproject';
import Sharedproject from './Sharedproject';
import TrashedProjects from './TrashedProjects';
import Dashboard from '../Dashboard';
import Planandpricing from './Planandpricing';
import Templates from '../Templates/Templates';
import DashboardTemplates from './DashboardTemplates';
import DashboardThemes from './DashboardThemes';

const Projectdisplay = () => {

    const { project } = useParams();
    let page = project

    const projectrenderer = () => {
        switch (page) {
            case "myprojects":
                return (
                    <Myproject />
                )
            case "sharedprojects":
                return (
                    <Sharedproject />
                )
            case "trashedprojects":
                return (
                    <TrashedProjects />
                )
            case "dashboardTemplate":
                return (
                    <DashboardTemplates />
                )
            case "Themes":
                return (
                    <DashboardThemes />
                )
            default:
                return (
                    <Planandpricing />
                )
        }
    }

    return (
        <>
            <div className={styles.projectdisplay_outer}>
                {projectrenderer()}
            </div>
        </>
    )
}

export default Projectdisplay;